export default __webpack_public_path__ + "2c2f7fea6b65c8708013feec828fb676.png";